import { render, staticRenderFns } from "./MaxListPage.vue?vue&type=template&id=13534918&scoped=true&"
import script from "./MaxListPage.vue?vue&type=script&lang=js&"
export * from "./MaxListPage.vue?vue&type=script&lang=js&"
import style0 from "./MaxListPage.vue?vue&type=style&index=0&id=13534918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13534918",
  null
  
)

export default component.exports